import "./h2TitleStyle.css"

export default function H2Title({title, color, width}) {
    return (
        <h2
            className="sub-title-h2"
            style={ {color: color, width: width} }
        >
            {title}
        </h2>
    );
}